<script lang="ts" setup>
import { AppTypography } from '@/core/components';

withDefaults(
  defineProps<{
    title?: string;
    subtitle?: string;
    variant?: string;
    elevation?: number;
    maxWidth?: number | string;
    noGutters?: boolean;
    trimTitle?: boolean;
  }>(),
  {
    title: '',
    subtitle: '',
    variant: 'elevated',
    elevation: 0,
    maxWidth: 610,
    noGutters: false,
    trimTitle: false,
  }
);
</script>

<template>
  <v-card :max-width="maxWidth" width="100%" :variant="variant" :elevation="elevation">
    <v-card-item v-if="title || subtitle" class="text-center" :class="{ 'mb-6': !trimTitle }">
      <v-card-title v-if="title">
        <AppTypography element="h1" type="large">{{ title }}</AppTypography>
      </v-card-title>
      <v-card-subtitle v-if="subtitle">
        <AppTypography element="p" type="body-1">{{ subtitle }}</AppTypography>
      </v-card-subtitle>
    </v-card-item>
    <v-card-text :class="{ 'pa-0': noGutters }">
      <slot />
    </v-card-text>
    <template v-if="$slots.actions" #actions>
      <slot name="actions" />
    </template>
  </v-card>
</template>

<style lang="scss" scoped>
.v-card {
  gap: 24px;
  border-radius: 16px;
  background-color: white;

  @media (min-width: 768px) {
    padding: 32px, 16px, 32px, 16px;
  }
}

.v-card-title {
  line-height: unset !important;
  white-space: normal;
}

.v-card-subtitle {
  white-space: normal;
}
</style>
